export default __webpack_public_path__ + "static/media/result4.a0f3e352.png";